import { useEffect } from 'react';
import { useFormik } from 'formik';
import { Switch } from '../../../../../../shared/types/modules/switch';

export const useSwitchDetailGeneralInfo = (switchDetail?: Switch) => {
    const formik = useFormik({
        initialValues: {
            created_at: '',
            callId: '',
            createdBy: '',
            updatedBy: '',
            channel: '',
            typification1: '',
            typification2: '',
            official: '',
            ext: '',
            observation: '',
        },
        onSubmit: console.log,
    });

    useEffect(() => {
        const {
            created_at = '',
            callId: callInfoRaw = '',
            createdBy: createdByRaw = '',
            updatedBy: updatedByRaw = '',
        } = switchDetail || {};
        const callInfo =
            typeof callInfoRaw === 'string'
                ? callInfoRaw
                : (callInfoRaw as string) || '';
        const createdBy =
            createdByRaw && typeof createdByRaw === 'object'
                ? `${createdByRaw.name ?? ''} ${
                    createdByRaw.surname ?? ''
                }`.trim()
                : '';
        const updatedBy =
            createdByRaw && typeof updatedByRaw === 'object'
                ? `${updatedByRaw.name ?? ''} ${
                    updatedByRaw.surname ?? ''
                }`.trim()
                : '';
        const formattedCreatedAt =
            created_at instanceof Date
                ? created_at.toISOString()
                : created_at || '';
        const channelName =
            typeof switchDetail?.channel === 'object' &&
            switchDetail?.channel?.name
                ? switchDetail.channel.name
                : '';
        const typificationName1 =
            typeof switchDetail?.typification1 === 'object' &&
            switchDetail?.typification1?.name
                ? switchDetail.typification1.name
                : '';
        const typificationName2 =
            typeof switchDetail?.typification2 === 'object' &&
            switchDetail?.typification2?.name
                ? switchDetail.typification2.name
                : '';
        const typificationName3 = switchDetail?.official ?? '';
        const typificationName4 = switchDetail?.ext ?? '';

        formik.setValues({
            created_at: formattedCreatedAt,
            callId: callInfo,
            createdBy,
            updatedBy,
            channel: channelName,
            typification1: typificationName1,
            typification2: typificationName2,
            official: typificationName3,
            ext: typificationName4,
            observation: switchDetail?.observation || '',
        });
    }, [switchDetail]);

    return {
        formik,
    };
};
